import { AxiosResponse } from "axios";
import { Config } from "../config";
import apiClient from "./apiClient";

const searchUsersByName = async (params: {
  name: string;
  page?: number;
}): Promise<AxiosResponse> => {
  let url = Config.endPoint.searchUserByName.replace("{name}", params.name);

  // Add page parameter if provided
  if (params.page) {
    url += `&page=${params.page}`;
  }

  const response = await apiClient.instance.get<any>(url);
  return response;
};

const searchCustomerByName = async (params: {
  name: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.get<any>(
    Config.endPoint.searchCustomerByName.replace("{name}", params.name)
  );
  return response;
};

const searchStories = async (params: {
  searchText: string;
  pageSize: number;
  pageNumber: number;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<any>(
    Config.endPoint.searchStories,
    params
  );
  return response;
};

export const SearchService = {
  searchUsersByName,
  searchCustomerByName,
  searchStories,
};
